import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #ffffff;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 00px 20px;
  background-color: white;
  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: calc(100vh - 135px);

  overflow-y: scroll;

  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
  }
`;

export const Wrapper = styled.div`
  padding: 0 100px;

  @media (max-width: 1360px) {
    padding: 0 50px;
  }

  @media (max-width: 769px) {
    padding: 0 15px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  .title {
    display: flex;

    @media (max-width: 768px) {
      margin-left: 1.8rem;
    }

    img {
      @media (max-width: 768px) {
        width: 12%;
      }

      @media (min-width: 768px) {
        margin-bottom: 1rem;
      }
    }
  }

  .container-input {
    width: 40%;

    @media (max-width: 768px) {
      width: 90%;
      margin: 1rem 1rem -1.5rem 1rem;
    }
  }

  h3 {
    margin: 0.35rem 0 0 1.2rem;
    color: #808080;

    @media (max-width: 768px) {
      font-size: 1.4rem;
    }
  }

  input {
    border: 1px solid #949494;
    padding: 0.3rem 1rem 0.3rem 1rem;
    border-radius: 1.2rem;
    width: 100%;
  }
`;

export const FielterContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 24px;
`;

export const FielterButton = styled.div`
  width: auto;
  height: auto;
  padding: 7px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #d6d6d6;
  border-radius: 50px;
  color: #808080;
  font-size: 13px;
  margin-bottom: 30px;
  cursor: pointer;

  &:nth-child(1) {
    margin-right: 20px;
  }

  ${props => props.active && 'background-color: #000FFF'};
  ${props => props.active && 'border: 1px solid #000FFF'};
  ${props => props.active && 'color: #ffffff'};
`;

export const EmployeeListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const HeaderMobile = styled.div`
  width: 100%;
  height: auto;
  display: none;
  align-items: center;
  justify-content: center;
  background-color: #000FFF;
  color: #ffffff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 5px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const HeaderIcon = styled.i`
  font-size: 29px;
  color: #ffffff;
`;

export const HeaderText = styled.span`
  font-size: 15px;
  color: #ffffff;
`;

export const NextPage = styled.span`
  color: #000FFF;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
`;

export const NextPageContainer = styled.div`
  display: flex;
  justify-content: ${props => props.content};
  margin-bottom: 1.5rem;
  color: #000FFF;
`;

export const TextNoResults = styled.span`
  text-align:center;
  color:#808080;
`;


export const CloseIconContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0;
  margin-bottom:20px;
`;

export const CloseIcon = styled.div`
  font-size: 28px;
  color: #808080;
  cursor: pointer;
`;
